export { default as useGetProductsMetadata } from './useGetProductsMetadata';
